import styled, { css } from "styled-components";

export const VideoButtonWrapper = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;

  ${({ $isVisible }) =>
    !$isVisible &&
    css`
      display: none;
    `};
`;

export const WatchButtonWrapper = styled.div`
  position: relative;
  width: 260px;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  z-index: 2;

  ${({ $isHidden }) =>
    !!$isHidden &&
    css`
      pointer-events: none;
      visibility: hidden;
    `};
`;

export const WatchCloseButton = styled.button`
  box-sizing: border-box;
  padding: 0px;
  width: 20px;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  outline: none;
  box-shadow: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
  z-index: 3;

  &:hover {
    opacity: 0.85;
  }
`;

export const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 4px 20px 4px 4px;
  background-color: #1d1d1d;
  border-radius: 12px;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: #ffffff;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5em;
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    top: 38.26px;
    left: 64px;
    width: 131px;
    height: 55.57px;
    background-color: #fc714a;
    filter: blur(32px);
    border-radius: 59.05549240112305px;
    opacity: 0.3;
  }

  &:hover {
    opacity: 0.85;
  }
`;

export const VideoIconWrapper = styled.div`
  width: 56px;
  height: 34px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
    url("/images/hero/video-placeholder.png");
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px solid #ffffff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const PlayIcon = styled.svg`
  width: 16px;
  height: 16px;
  fill: #ffffff;
`;

export const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9998;
  cursor: pointer;
`;

export const VideoPlayerLightbox = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 1125px;
  max-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: none;

  ${({ $isOpen }) =>
    !$isOpen &&
    css`
      pointer-events: none;
      visibility: hidden;
    `}

  @media ${({ theme }) => theme.media.mobile} {
    width: 95%;
    max-height: 85vh;
  }
`;

export const VideoContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: auto;
  max-height: 90vh;
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 16px;
  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;
  overflow: hidden;
  pointer-events: auto;
  position: relative;

  video {
    width: 100%;
    height: auto;
    display: block;
  }

  @media ${({ theme }) => theme.media.mobile} {
    max-height: 85vh;
    border-radius: 12px;
  }
`;

export const CloseButton = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  position: absolute;
  width: 32px;
  height: 32px;
  right: 8px;
  top: 8px;
  background: #ffffff;
  outline: none;
  box-shadow: none;
  border: 1.00468px solid rgba(29, 29, 29, 0.1);
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
  z-index: 3;

  &:hover {
    background-color: rgba(29, 29, 29, 0.04);
    border: 1px solid rgba(29, 29, 29, 0.5);
  }
`;

export const CloseIcon = styled.img.attrs({
  alt: "cross",
  src: "/images/icons/cross.svg",
})`
  width: 20px;
  height: 20px;
`;
